module.exports = __webpack_public_path__ + "media/markers/default-active@2x-9cc7d5d5.png";